module.exports = __webpack_public_path__ + "static/bg-for-who-964a9977ea99e562937cc228bde38995.jpg";